﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Prenumeration",
  "change": "Ändra",
  "currency": "USD",
  "save": "Spara",
  "save17Percent": "<strong>Spara {{percent}}%</strong> med en årsplan",
  "save17PercentNoBold": "Spara {{percent}}%",
  "yearly": "Årlig",
  "monthly": "Månadsvis",
  "Lifetime": "Livstid",
  "PerMonth": "Per månad",
  "PerYear": "Per år",
  "Free": "Gratis",
  "optional": "valfri",
  "trialLengthTrial": "<0>{{ trialLength }}</0>dagars provversion",
  "viewAllPlans": "Visa alla alternativ",
  "myBoardmaker": "My Boardmaker",
  "canada": "Kanada",
  "unitedStates": "USA",
  "oneMomentPlease": "Ett ögonblick ...",
  "software": "Mjukvara",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Fullständig",
  "loadingRegions": "Läser in tillgängliga regioner",
  "loadingPartners": "Läser in tillgängliga partners",
  "supportedPeripherals": "Externa enheter som stöds",
  "pleaseWait": "Vänta...",
  "minimum": "Minimum",
  "recommended": "Rekommenderat",
  "browser": "Webbläsare",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "behöver hjälp att välja",
  "or": "eller",
  "advantages": "Fördelar",
  "visitPartnerSite": "Besök partner-webbplats",
  "recentOrders": "Senaste beställningarna",
  "current": "aktuell",
  "orLater": "eller senare",
  "customerSupport": "kundtjänst",
  "proratedAmount": "Proportionellt belopp",
  "community": {
    "community": "Community",
    "getStartedNow": "Kom igång nu!"
  },
  "personal": "Personlig prenumeration",
  "professional": "Professionell prenumeration",
  "planCard": {
    "noCCRequired": "Inget kreditkort krävs",
    "cCOnly": "Endast kreditkort",
    "cCOrPO": "Kreditkort eller inköpsorder",
    "myPlan": "Min plan",
    "currentPlan": "Aktuell plan",
    "downgradeNotice": "Ändringarna börjar gälla när den aktuella planen förfaller.",
    "upgradeNotice": "Ändringarna börjar gälla omgående."
  },
  "selectedPlanSummary": {
    "summary": "Sammanfattning",
    "change": "$t(change)",
    "subtotal": "Delsumma"
  },
  "action": {
    "joinToday": "Gå med idag!",
    "finish": "Slutför",
    "subscribe": "Prenumerera",
    "resubscribe": "Prenumerera på nytt",
    "requestAQuote": "Begär en offert",
    "try": "Prova",
    "startTrial": "Starta en testperiod",
    "buyNow": "Köp nu",
    "tryIt": "Pröva det",
    "tryItFree": "Prova gratis i 30 dagar!",
    "free": "gratis",
    "getStarted": "Kom igång",
    "forTrialDays": "i <1>{{trialLength}}</1> dagar",
    "comparePlans": "Jämför alternativ",
    "hideComparisons": "Göm alternativ",
    "learnMore": "Läs mer",
    "start": "Starta",
    "next": "Nästa",
    "edit": "Redigera",
    "cancel": "Avbryt",
    "imTaxExempt": "Skattefritt",
    "submit": "Skicka",
    "print": "Skriv ut",
    "backToPaymentDetails": "Tillbaka till betalningsinformation",
    "close": "Stäng",
    "back": "Tillbaka",
    "continue": "Fortsätt",
    "uploading": "Laddar upp",
    "delete": "Ta bort",
    "update": "Uppdatera",
    "generatingInvoice": "Skapar faktura",
    "proceed": "Fortsätt",
    "modify": "Ändra",
    "yes": "Ja",
    "signUp": "Registrera dig",
    "downloads": "Nedladdningar"
  },
  "status": {
    "loading": "Laddar...",
    "creatingAccount": "Skapar konto...",
    "submitting": "Skickar...",
    "submittingPayment": "Skickar betalning...",
    "submittingRequest": "Skickar begäran..."
  },
  "planComparison": {
    "label": "Vilka är fördelarna med varje plan?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Jämförelse av funktioner",
    "subheader": "Världens favoritlösning för att skapa oändlig symbolbaserad kommunikation och visuellt stöd!"
  },
  "account": {
    "email": "E-post",
    "accountFoundTitle": "Konto hittat",
    "accountFoundMessage": "Ett konto med denna e-postadress finns redan. Vill du logga in med det kontot eller använda en annan e-postadress och skapa ett nytt konto?",
    "signedOutElsewhereTitle": "Du har blivit utloggad",
    "signedOutElsewhereMessage": "Du blev utloggad i en annan flik. Logga in igen för att fortsätta, eller stäng detta för att fortsätta surfa utan ett konto.",
    "signedOutElsewhereDismiss": "Fortsätt surfa",
    "federatedEmailTitle": "Organisations-e-post identifierad",
    "federatedEmailMessage": "Den här e-postadressen använder din organisations inloggning. Logga in för att komma åt Boardmaker via din organisation, eller använd en annan e-postadress för att skapa ett nytt konto.",
    "federatedEmailUseDifferent": "Använd en annan e-postadress",
    "logIn": "Logga in",
    "logOut": "Logga ut",
    "loggingIn": "Loggar in...",
    "loggingOut": "Loggar ut...",
    "verifying": "Verifierar...",
    "loggingInMessage": "Loggar in dig...",
    "createAccount": "Skapa konto",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Har redan ett ",
    "login2": "Tobii Dynavox",
    "login3": "-konto",
    "loginPrompt": "Har du redan ett <1>Tobii Dynavox account</1>? <3>Logga in</3>",
    "cancelSubscription": "Avbryt prenumeration",
    "areYouSure": "Är du säker på att du vill välja denna plan? Om du fortsätter sker följande:",
    "cancelSubscriptionProcess": "Avbryt prenumerationsprocessen (dina aktuella framsteg går förlorade)",
    "changeToCommunityPlan": "Ändra ditt konto till en gemensam plan",
    "onceYouveCompletedYourProfile": "När din profil är klar, ch du bestämmer dig för att uppgradera din plan, kan du när som helst göra det från delen Mitt konto.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Hämtar användarinformation"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Fyll i uppgifterna ovan så blir du kontaktad av en kundansvarig inom kort.",
    "fillOutDetailsBelowLicense": "Fyll i uppgifterna ovan så blir du kontaktad av en säljrepresentant inom kort."
  },
  "forms": {
    "confirmEmail": "Bekräfta e-post",
    "billingDetails": "Faktureringsuppgifter",
    "paymentType": "Betalningstyp",
    "creditCardType": "Betalningstyp",
    "creditCard": "Kreditkort",
    "purchaseOrder": "Inköpsorder",
    "cardNumber": "Kortnummer",
    "expirationDate": "Förfallodatum",
    "cardholderName": "Kortinnehavarens namn",
    "cardSecurityCode": "Kortets säkerhetskod",
    "securityCode": "Säkerhetskod",
    "organizationName": "Organisationens namn",
    "accountsPayableEmail": "Kontobetalarens e-postadress",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "addressLine": "Adressrad 1",
    "addressLine2": "Adressrad 2",
    "country": "Land",
    "language": "Språk",
    "city": "Stad",
    "stateProvinceRegion": "Stat/provins/region",
    "zipPostalCode": "Postnummer",
    "month": "Månad",
    "year": "År",
    "optional": "valfri",
    "username": "Användarnamn",
    "name": "Namn",
    "phoneNumber": "Telefonnummer",
    "phone": "Telefon",
    "email": "E-post",
    "url": "URL",
    "selectYourCountry": "Välj land",
    "selectYourState": "Välj stat",
    "selectYourProvinceTerritory": "Välj provins eller territorium",
    "selectYourTerm": "Välj period",
    "1year": "1 år",
    "2years": "2 år",
    "3years": "3 år",
    "4years": "4 år",
    "5years": "5 år",
    "instructorLogins": "Antal instruktörsinloggningar",
    "studentLogins": "Antal elevinloggningar",
    "term": "Period",
    "tradeIn": "Behörig för inbytesrabatt?",
    "legacyVersions": "Har du äldre versioner av Boardmaker att byta in för att få rabatt på myBoardmaker?",
    "selectAResponse": "Välj ett svar",
    "yes": "Ja",
    "no": "Nej",
    "notSure": "Inte säker",
    "password": "Lösenord",
    "confirmPassword": "Bekräfta lösenord",
    "additionalInformationOrQuestions": "Ytterligare information eller frågor",
    "countryNotSupported": "---",
    "uploadDocument": "Ladda upp dokument",
    "chooseFile": "Välj fil",
    "paymentMethod": "Betalningsmetod",
    "purchaseOrdersAreOnlyProcessed": "Inköpsordrar bearbetas först när din beställning är skickad, så de kan ändras när som helst innan dess.",
    "PONumber": "Inköpsordernummer",
    "PONotes": "Inköpsorder noteringar",
    "iVerifyThatImAuthorized": "Jag intygar att jag är behörig att skicka denna inköpsorder.",
    "submissionSuccessful": "Skickad!",
    "thankYourForYourRequest": "Tack för din förfrågan! En kundansvarig kontaktar dig inom kort.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Antal licenser",
    "pleaseEnterYourName": "Skriv ditt namn exakt som det visas på kortet",
    "needHelpFindingSecurityCode": "Behöver du hjälp att hitta kortets säkerhetskod"
  },
  "validation": {
    "required": "Obligatorisk",
    "invalidEmail": "Ogiltig e-postadress",
    "emailsMustMatch": "E-postadresserna måsta matcha",
    "passwordsMustMatch": "Lösenorden måste matcha",
    "errorOccurred": "Ett fel inträffade när formuläret skickades",
    "tryAgain": "Försök igen. Kontakta supporten om problemet kvarstår.",
    "errorOccurredPDF": "Ett fel inträffade när PDF-fakturan lästes in",
    "password": {
      "minLength": "Lösenordet måste bestå av minst 8 tecken",
      "tooShort": "För kort",
      "checking": "Kontrollerar..."
    },
    "USZipCode": "Måste ange ett postnummer i USA",
    "CAZipCode": "Måste ange ett postnummer i Kanada.",
    "invalidCardNumber": "Ogiltigt kolumnnummer",
    "invalidCardType": "Ogiltig korttyp",
    "invalidExpirationDate": "Ogiltigt förfallodatum",
    "invalidSecurityCode": "Ogiltig säkerhetskod",
    "securityCodeNumericWarning": "Säkerhetskoden får endast innehålla siffror",
    "invalidUsernameWarning": "Ogiltigt användarnamn. Får endast innehålla bokstäver och siffror.",
    "usernameMaxLengthWarning": "Användarnamnet får inte vara längre än 60 tecken.",
    "badZip": "Valt postnummer är inte giltigt för den valda staten.",
    "badPostalCode": "Valt postnummer är inte giltigt för vald provins eller valt territorium.",
    "canadianAddressNeedsCad": "Kanadensiska faktureringsadresser faktureras i kanadensiska dollar. Fortsätt genom att välja flaggan högst upp på sidan och sedan Kanada."
  },
  "invoice": {
    "communityHeader": "Inget kreditkort. Endast gratisåtkomst till myBoardmaker Community. Behåll dina data och framsteg om du beslutar att uppgradera till en betald prenumeration. Vad väntar du på?",
    "trialHeader": "Inga restriktioner. Inget kreditkort. Behåll dina data och framsteg om du beslutar att omvandla din testversion till en betald prenumeration. Vad väntar du på?",
    "plan": "Plan",
    "term": "Period",
    "price": "Pris",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Betalningsinformation",
    "endingWith": "Slutar med",
    "expires": "Förfaller",
    "orderSummary": "Beställningsöversikt",
    "orderDate": "Beställningsdatum",
    "orderNumber": "Beställningsnummer",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Skatt",
    "total": "Totalt",
    "aConfirmationEmail": "Ett e-postmeddelande med beställningsbekräftelse har skickats till",
    "printOrderSummary": "Skriv ut beställningsöversikt",
    "recurringPaymentDisclaimer": "Din beställning inkluderar en <strong>återkommande betalning</strong> på ett belopp av <3>{{amount}}</3> som förnyas <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Vi debiterar dig <strong>{{amount}}</strong> <strong>{{date}}</strong>, när din nya prenumeration startar.",
    "PODisclaimer": "Din prenumeration är nu aktiv och klar att använda. För att tjänsten inte ska avbrytas måste vi ha din betalning inom <strong>30 dagar</strong>. Om betalningen inte är oss tillhanda <4>{{date, LL}}</4> kommer ditt konto konverteras till ett gratis communitykonto till dess att beloppet är betalt.",
    "purchaseOrderNumber": "Inköpsordernummer",
    "orgNotes": "Inköpsorder noteringar",
    "pleaseSendACopyOfYourInvoice": "Skicka din betalning och en kopia av din faktura till:",
    "ifYourPurchaseOrdersReady": "Om din inköpsorder är klar kan du ladda upp den nu.",
    "supportedFileTypes": "Filtyper som stöds: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " När det blir dags skickar vi ett e-postmeddelande till <1>{{email}}</1> och påminner dig om nästa betaldatum.",
    "uploadSuccessful": "Har laddats upp.",
    "yourAccountWillContinue": "Tack för din inköpsorder. Vid förnyelse av din prenumeration kan det ta upp till 14 dagar för din beställning att hanteras. När den är klar får du ett e-postmeddelande som bekräftar slutförandet tillsammans med din faktura.",
    "billing": "Faktureringsadress",
    "payment": "Betalningsmetod",
    "ifYourPurchaseOrderIsReady": "Om din inköpsorder är klar kan du ladda upp den nu.",
    "PODisclaimer1": "Din prenumeration är nu aktiv och klar att använda.",
    "PODisclaimer2": "Betalningen måste vara oss tillhanda inom 30 dagar, annars konverteras ditt konto automatiskt till ett gratis communitykonto.",
    "POStartsLaterDisclaimer": "Vi skickar din faktura <strong>{{date}}</strong>, när din nya prenumeration startar. Betalningen ska vara oss tillhanda inom 30 dagar från det datumet."
  },
  "legal": {
    "privacyPolicy": "Sekretesspolicy",
    "studentPolicy": "Studentdatapolicy",
    "termsAndConditions": "Regler och villkor",
    "termsOfService": "Användarvillkor",
    "tdTermsAndConditions": "Jag accepterar Tobii Dynavox <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Kontakta oss"
  },
  "errors": {
    "error": "Fel",
    "loadingPlans": "Läser in planer",
    "sorry": "Förlåt! Det är vårt fel, inte ditt...",
    "somethingWentWrong": "Något gick fel från vår sida. Vi har loggat felet och uppmanar dig att <1>{{link}}</1> om detta fel inträffar igen.",
    "tryGoingBack": "Prova att backa eller <1>{{link}}</1>",
    "downloadList": "Kunde inte läsa in nedladdningslistan."
  },
  "404": {
    "sorry": "Tyvärr, vi kunde inte hitta den sidan",
    "oldLink": "Länken kan vara gammal eller så har sidan flyttat.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Starta din gratis testversion nu!",
    "startYourFreeTrial": "Starta din gratis testversion",
    "todayWhichIncludesAccessForThirtyDays": " idag, vilken inkluderar åtkomst i 30 dagar!"
  },
  "navigation": {
    "bmoRedirect": "Omdirigerar dig till myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Vi hoppas att du gillade din 30 dagars obegränsade förhandsgranskning. Din testversion har konverterats till en gratis Community-plan och alla dina data och framsteg* har sparats. För att komma åt de premiumfunktioner du hade under provperioden behöver du bara uppgradera till en månads- eller årsprenumeration.",
    "dataAndProgress": "* Data och framsteg som är kopplade till premiumfunktioner är endast tillgängliga med en komplett betald prenumeration."
  },
  "currencySelector": {
    "header": "Välja land och språk",
    "disclaimer": {
      "USD": "Välj USA om ditt land inte finns med"
    }
  },
  "taxExempt": {
    "us&ca": "Endast USA och Kanada",
    "taxExemptionProgram": "Använd detta formulär för att skicka dina dokument om skattebefrielse. Vi kontaktar dig via e-post inom tre dagar för att bekräfta din status som skattebefriad. När du mottagit detta bekräftelsemeddelande kan du göra din skattefria beställning. Om du gör din beställning innan du fått bekräftelsen kommer du att debiteras en ej återbetalningsbar skatt.",
    "taxExemptionProgramExisting": "Använd detta formulär för att skicka dina dokument om skattebefrielse. Vi kontaktar dig via e-post inom tre dagar för att bekräfta din status som skattebefriad. När du har fått bekräftelsemeddelandet kommer inga framtida köp och förnyelser av prenumerationer att beskattas. Skatt som betalats för köp gjorde före bekräftelsen om skattebefrielse kommer inte att betalas tillbaka.",
    "yourSubmissionWasSuccessfulNew": "Din begäran är skickad. Vår personal kommer att granska din information och du bör få en bekräftelse via e-post inom tre dagar som verifierar att din ansökan behandlats. När den är godkänd kan du genomföra din skattefria beställning. Under tiden har vi skapat ett gratis Communitykonto åt dig så att du kan börja undersöka vad myBoardmaker har att erbjuda.",
    "yourSubmissionWasSuccessfulExisting": "Din begäran är skickad. Vår personal kommer att granska din information och du bör få en bekräftelse via e-post inom tre dagar som verifierar att din ansökan behandlats. När den är godkänd kan du göra din nästa betalning skattefritt."
  },
  "modify": {
    "contactCustomerSupport": "Kontakta <1>{{supportLink}}</1> för att ändra din prenumeration",
    "billingDetails": "Ändra faktureringsuppgifter",
    "paymentModalHeader": "Uppdaterad!",
    "paymentModalBody": "Dina ändringar kommer att synas vid din nästa faktureringscykel.",
    "thankYou": "Tack för din betalning!",
    "daysRemaining": "dagar kvar",
    "dueDisclaimer": "Om betalningen inte är oss tillhanda inom 30 dagar kommer ditt konto automatiskt att konverteras till ett gratis communitykonto till dess att beloppet är betalt.",
    "lateDisclaimer": "Betala hela beloppet för att undvika att din prenumeration avbryts. Om vi inte får någon betalning kommer ditt konto automatiskt att konverteras till ett gratis communitykonto till dess att beloppet är betalt.",
    "nextPaymentDueIn": "Nästa betalning är om",
    "days": "dagar",
    "paymentIs": "Betalningen är",
    "daysPastDue": "dagar försenad",
    "recurringPaymentDisclaimer": "Din <1>plan eller beställning</1> inkluderar en <strong>återkommande betalning</strong> på ett belopp av <4>{{amount}}</4> som förnyas <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Din plan inkluderar en <strong>återkommande betalning</strong> som förnyas <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Du kan skicka din inköpsorder med någon av metoderna som nämns nedan. Kontakta vår kundtjänst för att återaktivera din prenumeration.",
    "yourAccountHasBeenConverted": "Ditt betalkonto har konverterats till ett gratis communitykonto",
    "balanceDueIn": "Beloppet förfaller om",
    "subscriptionExpiresIn": "Prenumerationen förfaller om",
    "paymentPastDue": "Betalningen är försenad",
    "autoRenewal": "Automatisk förnyelse",
    "turnAutoRenewOff": {
      "header": "Inaktivera automatisk förnyelse av prenumeration",
      "areYouSure": "Är du säker på att du vill inaktivera automatisk förnyelse? Om du fortsätter sker följande:",
      "points": [
        "Avbryt din betalda prenumeration i slutet av den aktuella faktureringscykeln.",
        "Konvertera ditt konto till en gratis Community-plan i slutet av den aktuella faktureringscykeln.",
        "Du kommer at ha åtkomst till ditt innehåll efter konverteringen och du kan när som helst prenumerera igen för att få alla premiumfunktioner som betalda prenumerationer innehåller. ",
        "Om du ändrar dig innan din aktuella prenumeration upphör behöver du bara aktivera automatisk förnyelse igen."
      ],
      "footer": "Vill du inaktivera automatisk förnyelse?"
    },
    "turnAutoRenewOn": {
      "header": "Aktivera automatisk förnyelse",
      "areYouSure": "Funktioner för automatisk förnyelse av penumeration:",
      "points": [
        "Din prenumeration är inställd att förnyas automatiskt när den aktuella prenumerationsperioden är slut.",
        "Problemfri betalning med din sparade betalningsmetod.",
        "Vi skickar ett kvitto via e-post varje gång din prenumeration förnyas.",
        "Som alltid kan du när som helst ändra dina prenumerationsinställningar i Information om min plan.",
        "Ångrat dig? Inaktivera automatisk förnyelse före den aktuella prenumerationens sista dag så kommer du inte att debiteras."
      ],
      "footer": "Vill du aktivera automatisk förnyelse?"
    },
    "on": "På",
    "off": "Av",
    "pending": "väntar",
    "plan": "Plan",
    "term": "Period",
    "effective": "Gäller från",
    "subscription": "Prenumeration",
    "downgradeWarning": {
      "title": "Nedgradera prenumeration",
      "prompt": "Är du säker på att du vill välja denna plan? Om du fortsätter sker följande:",
      "planChange": "Nedgradera din prenumeration från Professionell till Personlig i slutet av den aktuella faktureringscykeln",
      "termChange": "Nedgradera din period från Årlig till Månatlig i slutet av den aktuella faktureringscykeln",
      "changeNote": "Dina ändringar kommer att synas vid din nästa faktureringscykel.",
      "termChangeMultiToYearly": "Nedgradera din flerårsperiod till en ettårsperiod i slutet av den aktuella faktureringscykeln",
      "termChangeMultiToMonthly": "Nedgradera din flerårsperiod till en månadsperiod i slutet av den aktuella faktureringscykeln"
    },
    "futureAmendmentThankYou": "Dessa ändringar börjar gälla då den aktuella faktureringscykeln är slut. En faktura blir tillgänglig när dessa ändringar tillämpats på ditt konto. Om du vill ändra en väntande ändring, ring <1>kundtjänst</1>.",
    "futureAmendmentDisclaimer": "Din aktuella <1>{{planName}}</1>-plan förfaller <3>{{startEndDate}}</3>. Din nya <5>{{selectedPlanName}}</5>-plan startar <7>{{startEndDate}}</7> och förnyas automatiskt <9>{{term}}</9>.",
    "modificationPending": "Ändring av plan väntar",
    "paymentDeclined": "Förnyelsetransaktionen för din prenumeration avvisades. Ändra din betalningsmetod senast <1>{{date}}</1> annars avslutas din prenumeration.",
    "continueSubscription": "Din prenumeration förfaller <1>{{ date1 }}</1>. Om du vill fortsätta din prenumeration ytterligare {{term}}, aktivera automatisk förnyelse senast <5>{{ date2 }}</5> så hanterar vi din betalning följande dag.",
    "discontinuedRatePlan": "Din aktuella prenumerationsplan är inte längre tillgänglig. Välj ett annat alternativ.",
    "cancelYourSubscription": "Om du vill avbryta din prenumeration och få en fullständig återbetalning måste du kontakta <1>{{supportLink}}</1> före <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Ändra prenumeration",
    "cancelCardText": "Du kan avbryta din prenumeration när som helst. Men vi skulle gärna se att du stannar.",
    "cancelConfirmTitle": "Är du säker på att du vill avbryta din prenumeration?",
    "cancelConfirmIntro": "Din nuvarande plan förblir aktiv till <strong>{{date}}</strong>. När din plan upphör:",
    "cancelConsequences": [
      "Du förlorar åtkomsten till premiumfunktioner.",
      "Du går miste om exklusiva fördelar som ingår i din prenumeration.",
      "Fördelarna med din prenumeration upphör när din nuvarande plan går ut."
    ],
    "keepSubscription": "Behåll min prenumeration",
    "confirmCancel": "Nej, jag vill avbryta",
    "cancelledTitle": "Din prenumeration har avbrutits!",
    "cancelledBody": "Din prenumeration har avbrutits. Du har inte åtkomst till ditt premiumkonto efter {{date}}.",
    "cancelledFarewell": "Vi är ledsna att se dig gå! Du är alltid välkommen tillbaka.",
    "done": "Klar",
    "cancelledNotice": "Din nuvarande <strong>{{planName}}</strong>-prenumeration upphör <strong>{{date}}</strong>. Förnya din prenumeration för att fortsätta använda våra premiumfunktioner.",
    "resubscribedNotice": "Din nya <strong>{{planName}}</strong>-prenumeration startar <strong>{{date}}</strong>, när den nuvarande upphör."
  },
  "tdAccount": {
    "title": "Tobii Dynavox-konto",
    "header": "Vad är ett Tobii Dynavox-konto med engångsinloggning (SSO)?",
    "body": "Ditt Tobii Dynavox-konto med engångsinloggning, som består av en e-postadress och ett lösenord, använder du för att logga in på alla våra webbplatser och appar. Tillsammans med våra förbättrade säkerhetsfördelar ger engångsinloggning snabbare och bekvämare åtkomst till ditt innehåll i alla Tobii Dynavox-tjänster.",
    "haveA": "Har du ett",
    "tobiiDynavoxAccount": "Tobii Dynavox-konto?"
  },
  "redirectPageTitle": {
    "homePage": "Startsida",
    "profileCreation": "Skapa profil"
  },
  "download": {
    "downloadBoardmaker": "Ladda ned Boardmaker",
    "downloadBoardmakerStudentCenter": "Ladda ned Boardmaker Student Center",
    "downloadOtherVersions": "Ladda ned andra versioner",
    "downloadBoardmakerStudio": "Ladda ned Boardmaker Studio",
    "licenseKey": "Licensnyckel",
    "download": "Ladda ned",
    "licenseHelper": "Administration av licens",
    "discontinued": "Upphörde <1>{{discontinueDate}}</1>. Se <3>systemkrav</3>.",
    "mainFeatures": "Huvudfunktioner",
    "compatibility": "Kompatibilitet",
    "improvements": "Förbättringar",
    "bugFixes": "Buggfixar",
    "version": "Version",
    "discontinuedSupport": "Support har upphört",
    "releaseDate": "Utgavs  {{date}}",
    "discontinuedDate": "Upphörde {{date}}",
    "boardmakerSummary": "Tryck på knappen nedan för att ladda ned senaste versionen av Boardmaker Editor som används för att skapa och redigera aktiviteter.  Installationsprogrammet fungerar för alla kontotyper och stödda språk.",
    "studentCenterSummary": "Tryck på knappen nedan för att ladda ned senaste versionen av Boardmaker Student Center som används för att utföra Boardmaker-aktiviteter. Installationsprogrammet fungerar för alla kontotyper och stödda språk.",
    "boardmakerIntro": "Boardmaker 7 Editor är det främsta verktyget för att hjälpa lärare, terapeuter och föräldrar att skapa, redigera och dela Boardmaker-aktiviteter.  Stöd inlärning och kommunikation i klassrummet, terapirummet eller hemma med en mängd anpassningsbart material.",
"studentCenterIntro": "I kombination med vissa Boardmaker 7-prenumerationer kan lärare tilldela eleven aktiviteter i appen Boardmaker 7 Student Center och spåra deras framsteg.  Eleven kan slutföra sina aktiviteter i appen hemma eller i skolan.",
"boardmakerStudioIntro": "Med Boardmaker Studio kan personer som assisterar elever med funktionsnedsättningar skapa och redigera aktiviteter för att hjälpa eleverna att lära sig kommunicera med symboler, text samt syntetiskt och inspelat tal.",
"mobilePlayerIntro": "I kombination med vissa myBoardmaker-prenumerationer kan lärare tilldela eleven aktiviteter i appen Boardmaker Student Center och spåra deras framsteg.  Eleven kan slutföra sina aktiviteter i appen hemma eller i skolan.",
    "communityStartHeader": [
      "Begär åtkomst till din Community och lagring",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker är utformad för att fungera med Boardmakeronline.com, där du tryggt kan säkerhetskopiera dina personliga Boardmaker-filer och få åtkomst till vår globala Community. Community-medlemmar kan dela det de har skapat och hitta nya Boardmaker-aktiviteter från andra användare. Registrera ett gratis Communitykonto för åtkomst!",
      0,
      0
    ],
    "latestMobile": "För bästa upplevelse, ladda ned mjukvaran från en enhet som uppfyller <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "Systemkrav",
    "viewSystemRequirements": "Visa <1>{{guideLink}}</1> för systemkrav.",
    "onThisPage": "På den här sidan",
    "communityStart": {
      "header": "Begär åtkomst till din Community och lagring",
      "body": "Boardmaker är utformad att fungera med myboardmaker.com. Ditt kostnadsfria Boardmaker Community-konto inkluderar:",
      "pointOne": "Molnlagring - säker säkerhetskopiering av dina Boardmaker-filer och åtkomst till dem varifrån som helst!",
      "pointTwo": "Activities-to-Go - Nivåanpassad, tematisk kursplan klar att skriva ut och använda.",
      "pointThree": "Åtkomst till vår globala Community - dela det du har skapat och hitta nya Boardmaker-aktiviteter från andra användare.",
      "footer": "Registrera ett gratis Communitykonto för åtkomst!"
    },
    "BoardmakerCompatible": "Denna enhet är inte kompatibel med mjukvaran Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Denna enhet är inte kompatibel med programmet Boardmaker Student Center.",
    "BoardmakerMobile": "Boardmaker-program har inte stöd för denna funktion."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "prenumeration",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licens",
      "tolicenseText": "engångsköp",
      "mainText": "Föredrar du <1>{{ toggleText }}</1> eller <3>{{ helpLink }}</3>?",
      "preferencedText": "Föredrar du "
    },
    "comparison": {
      "accessTo": "Åtkomst till följande...",
      "title": "Hjälp mig att välja",
      "titleDescription": "En snabb titt på skillnaderna mellan en prenumeration på myBoardmaker och själva Boardmaker-programmet.",
      "titles": {
        "investment": "Investering",
        "includedSoftware": "Inkluderad mjukvara",
        "softwareUpdates": "Programuppdateringar",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Molnlagring",
        "curriculum": "Kursplan",
        "studentManagement": "Administration av elever"
      },
      "subscription": {
        "header": "Prenumeration på myBoardmaker",
        "investment": "Låg startkostnad och alternativ för månadsbetalning",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Inkluderat (2-3 gånger per år)",
        "pcsSymbols": "Alla symboler, inklusive nya symboler varannan vecka",
        "cloudStorage": ["Lagrade aktiviteter", "Lagrade media"],
        "curriculum": [
          "Boardmaker Activities to Go 10 teman x 4 enheter var",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": ["Tilldela aktiviteter\u00B9", "Spåra framsteg"]
      },
      "license": {
        "header": "Endast mjukvara",
        "investment": "Engångsköp av mjukvara",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Periodiska betalda uppgraderingar (var 2-3 år)",
        "pcsSymbols": "Alla tillgängliga symboler vid senaste utgivningsdatumet (PCS-prenumeration kommer inom kort)",
        "cloudStorage": "Lagrade aktiviteter",
        "curriculum": "Boardmaker Activities to Go 1 tema x 4 enheter",
        "studentManagement": "Ingen"
      },
      "note": "Användare kan administrera och lägga till uppgifter för individuella elever i den professionella prenumerationsplanen",
      "note2": "Kan endast nås med Student Center-spelare.",
      "note3": "Användare kan administrera och lägga till uppgifter för individuella elever i den professionella prenumerationsplanen",
      "localizationNoteOne": "Boardmaker 7-apparna finns på följande språk både för prenumerations- och livstidsanvändare (endast mjukvara)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Engelska (USA)",
        "Spanska",
        "Tyska",
        "Svenska",
        "Finska",
        "Ryska",
        "Danska",
        "Norska",
        "Franska",
        "Italienska",
        "Polska",
        "Portugisiska"
      ],
      "localizationNoteTwo": "Kursplanen och webbplatsen myBoardmaker.com finns endast på engelska."
    }
  },
  "systemRequirements": "Systemkrav",
  "releaseNotes": "Versionsinformation",
  "operatingSystem": {
    "title": "Operativsystem",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobil)",
    "windows": "Windows",
    "unknown": "Okänd"
  },
  "perpetual": {
    "trial": {
      "intro": "Inget kreditkort. Ingen bindning. Bara <1>{{trialLength}}</1> dagar i rad med obegärnsad åtkomst till vår senaste Boardmaker-mjukvara. När du har hämtat och installerat mjukvaran på din dator kan du begära en <3>{{trialLength}}</3>-dagars aktiveringsnyckel<5>*</5> inifrån mjukvaran.",
      "footnote": "<0>*</0>Provperioden startar den dag då mjukvaran aktiveras och förblir aktiv de följande <2>{{trialLength}}</2> dagarna.",
      "downloadFootnote": "<0>v{{version}}</0> inkluderar de senaste funktionerna och korrigeringarna. Se <2>systemkrav</2>."
    },
    "thankyou": {
      "intro": "Leta reda på beställningsbekräftelsen i din e-post med nedladdningslänkar och aktiveringsnyckel för Boardmaker. Vi har också bifogat informationen nedan. Ladda ned och installera Boardmaker på din dator och använd sedan aktiveringsnyckeln för att aktivera programmet. När det är aktiverat får du ett års gratis uppdateringar. <1>Se till att spara aktiveringsnyckeln för framtida bruk.</1>"
    },
    "latest": "Senaste",
    "legacy": "Äldre"
  },
  "countries": {
    "us": "USA"
  },
  "currencyChange": {
    "header": "Valutaväxling",
    "body": "För närvarande kan köp inte göras med valuta från ditt valda land. Om du fortsätter kommer valutan att ändras till USA-dollar - USD."
  },
  "partner": {
    "body": "Den valda partnern, eller hjälpmedelsleverantören, kommer att vara din huvudsakliga kontakt för alla produktrelaterade och tekniska frågor.",
    "contactUs": "Om visat land inte är korrekt, ",
    "contactCustomerService": "kontakta kundtjänst."
  }
}
